module.exports = __webpack_public_path__ + "static/media/show-button-on.cd57c449.png";